import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TdsService {

  
  constructor(private crudSer: CrudService,private http: HttpClient) {

  }

  getTDS(vendorCode: string) {
    return this.crudSer.getTDS<any>(`TDSCertificate/Get?vendorCode=${vendorCode}`);
  }

  DownloadFile1(id: number): Observable<any> {
    return this.crudSer.getTDS<any>('TDSCertificate/GetFileDetails?id=' + id);
  }

  
  
  DownloadFile(id: number) {
    this.crudSer.getTDS<any>('TDSCertificate/GetFileDetails?id=' + id).subscribe({
      next: (response) => {
        console.log(response); // Handle the response
        this.ConvertFile(response.fileContents,response.fileDownloadName,response.contentType);
        // if (response.status) {
        //   //this.dataList = response.data;
        // }
        // else {
        //   this.dataList = [];
        //   console.log(response.message);
        // }
      },
      error: (error) => {
        console.error('Error occurred:', error); // Handle errors
      },
      complete: () => {
        console.log('Observable completed'); // Optional: Handle completion
      }
    });
  }


  ConvertFile(base64String: string, fileName: string, fileType: string) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });

    // Create a download link and trigger click
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

}
